import { ButtonHTMLAttributes, ReactNode } from 'react';
import { SpaceProps, LayoutProps } from 'styled-system';

import { TypographyStyle } from 'src/packages/core/text/Text.types';
import { ThemeType } from 'src/packages/theme';

export enum ButtonPadding {
  LARGE = '16px 30px',
  DEFAULT = '10px 24px',
  MEDIUM = '8px 16px',
  SMALL = '6px 10px',
}

export enum ButtonSize {
  LARGE = '60px',
  DEFAULT = '48px',
  MEDIUM = '40px',
  SMALL = '36px',
}

export enum IconSize {
  LARGE = '24px',
  DEFAULT = '16px',
  MEDIUM = '16px',
  SMALL = '14px',
}

export type ButtonVariant =
  | 'primaryLarge'
  | 'primaryDefault'
  | 'primaryMedium'
  | 'primarySmall'
  | 'secondaryLarge'
  | 'secondaryDefault'
  | 'secondaryMedium'
  | 'secondarySmall'
  | 'brandLarge'
  | 'brandDefault'
  | 'brandMedium'
  | 'brandSmall'
  | 'ghostLarge'
  | 'ghostDefault'
  | 'ghostMedium'
  | 'ghostSmall'
  | 'tertiaryLarge'
  | 'tertiaryDefault'
  | 'tertiaryMedium'
  | 'tertiarySmall';

export interface CustomButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  textColor?: string;
  variant?: ButtonVariant;
  isLoading?: boolean;
  onClick?: () => void;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  theme?: ThemeType;
}

export interface ButtonStyles extends TypographyStyle {
  backgroundColor: string;
  backgroundColorHover: string;
  backgroundColorDisabled: string;
  border: string;
  borderImage?: string;
  borderHover: string;
  borderDisabled: string;
  color: string;
  colorHover: string;
  iconColor: string;
  iconColorHover: string;
  iconSize: IconSize;
  colorDisabled: string;
  padding: string;
  height: ButtonSize;
}

export type ButtonProps = CustomButtonProps & SpaceProps & Pick<LayoutProps, 'minWidth' | 'width'>;
